__turbopack_context__.v({
  "destructive": "LinkButton-module__l7nirG__destructive",
  "discount": "LinkButton-module__l7nirG__discount",
  "main": "LinkButton-module__l7nirG__main",
  "primary": "LinkButton-module__l7nirG__primary",
  "secondary": "LinkButton-module__l7nirG__secondary",
  "suggested": "LinkButton-module__l7nirG__suggested",
});
